import { CaseState } from '@debbie/common/dist/cases/index.js';
import { AggregationType } from '@debbie/common/dist/insights/aggregations.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as reportsAPI from '@debbie/cortex/dist/api/insights.js';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useCaseFilter } from '@debbie/cortex/dist/insights/caseFilter.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import Button from '../Button.js';
import Checkbox from '../Checkbox.js';
import { Col, Row } from '../Grid/index.js';
import EmailLarge from '../Icons/EmailLarge.js';
import Modal from '../Modal.js';
import Select from '../Select.js';
import Well from '../Well.js';
import Aggregation from './Aggregation.js';
import BulkActions from './BulkActions.js';
import CaseFilterBadges from './CaseFilterBadges.js';
import filterGroups from './groups/index.js';
const AdvancedFilter = (props) => {
    const _caseFilter = useCaseFilter();
    const caseFilter = { ..._caseFilter, ...props.caseFilter };
    const tenant = useTenant();
    const exclusiveContent = useSelector(selectExclusiveContent);
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const lang = useSelector((s) => s.lang);
    const currentLang = useSelector((s) => s.currentLang);
    const [exportStarted, setExportStarted] = useState(false);
    const [orderCaseOverviewOpen, setOrderCaseOverviewOpen] = useState(false);
    const [aggregation, setAggregation] = useState(AggregationType.CountAll);
    const [caseOverviewDocuments, setCaseOverviewDocuments] = useState(false);
    const [caseOverviewVouchers, setCaseOverviewVouchers] = useState(false);
    const [caseOverviewRki, setCaseOverviewRki] = useState(false);
    const orderCaseOverviewMutation = useMutation(async () => {
        await reportsAPI.requestCaseOverviewReport([], currentLang, CaseState.ALL, undefined, caseOverviewDocuments, caseOverviewVouchers, caseOverviewRki, caseFilter);
        setExportStarted(true);
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.report);
        },
    });
    const hasExclusiveContent = !!(me && exclusiveContent?.includes(me.id));
    return (React.createElement("div", null,
        React.createElement(Row, null,
            React.createElement(Col, { width: "8" }, (tenant?.type
                ? filterGroups[tenant.type]
                : filterGroups[TenantType.Agency]).map((GroupComponent) => {
                return (React.createElement(GroupComponent, { onChange: props.onChange, caseFilter: caseFilter, hidePaginationGroup: props.hidePaginationGroup }));
            })),
            React.createElement(Col, { width: "4", style: { position: 'sticky', top: `${THEME.GRID_SPACING}px` } },
                React.createElement(Well, null,
                    React.createElement(Select, { value: aggregation || '', onChange: (e) => setAggregation(e.target.value || null) },
                        React.createElement("option", { disabled: true, value: "" },
                            "- ",
                            lang.aggregations.aggregate,
                            " -"),
                        Object.values(AggregationType)
                            .filter((type) => {
                            // Hide some for tenant.type=AccountsReceivable
                            if (tenant?.type === TenantType.AccountsReceivable &&
                                !hasExclusiveContent &&
                                [
                                    AggregationType.ByBillingAppendixSetup,
                                    AggregationType.ByBillingModel,
                                    AggregationType.ByCreditor,
                                ].includes(type)) {
                                return false;
                            }
                            return true;
                        })
                            .map((type) => (React.createElement("option", { key: type, value: type }, lang.aggregationTypes[type])))),
                    aggregation && (React.createElement(Aggregation, { caseFilter: caseFilter, type: aggregation })),
                    React.createElement(CaseFilterBadges, { caseFilter: caseFilter })),
                React.createElement(Button, { onClick: () => setOrderCaseOverviewOpen(true), style: { margin: '20px 0' }, block: true }, lang.caseFilter.orderCaseOverview),
                React.createElement(BulkActions, { caseFilter: caseFilter }))),
        orderCaseOverviewOpen && (React.createElement(Modal, { onToggle: () => {
                setExportStarted(false);
                setOrderCaseOverviewOpen(!orderCaseOverviewOpen);
            }, header: lang.caseFilter.orderCaseOverview, maxWidth: "350px" }, exportStarted ? (React.createElement("div", null,
            React.createElement(EmailLarge, { style: {
                    width: '8em',
                    height: '8em',
                    margin: '0 auto',
                    display: 'block',
                } }),
            React.createElement("h3", { style: { textAlign: 'center' } }, lang.insights.reportOrdered),
            React.createElement("p", { style: { textAlign: 'center' } }, lang.insights.reportOrderedText))) : (React.createElement(React.Fragment, null,
            React.createElement(Checkbox, { checked: caseOverviewDocuments, onChange: (e) => setCaseOverviewDocuments(e.target.checked), placeholder: lang.insights.includeDocuments }),
            React.createElement(Checkbox, { checked: caseOverviewVouchers, onChange: (e) => setCaseOverviewVouchers(e.target.checked), placeholder: lang.insights.includeVouchers }),
            React.createElement(Checkbox, { checked: caseOverviewRki, onChange: (e) => setCaseOverviewRki(e.target.checked), placeholder: lang.insights.includeRki }),
            React.createElement(Button, { loading: orderCaseOverviewMutation.isLoading, onClick: () => orderCaseOverviewMutation.mutate(), style: { margin: '20px 0' }, block: true }, lang.caseFilter.orderCaseOverview)))))));
};
export default AdvancedFilter;
//# sourceMappingURL=AdvancedFilter.js.map